import React, { useState, useContext } from "react";
import AppContext from "context/Context";
import { Accordion, Card, Col, Container, Form, Row, Tabs } from "react-bootstrap";
import FaqAccordionItem from "../faq/faq-accordion/FaqAccordionItem";
import { useTranslation } from "react-i18next";
import styles from "./landing.module.css";
import TabBox from "./TabBox";
import PageTitle from "components/common/PageTitle";
import createMarkup from "helpers/createMarkup";

document.addEventListener("DOMContentLoaded", function () {
	const cssToRemove = document.getElementById("css-to-remove");
	if (cssToRemove) {
		cssToRemove.parentNode.removeChild(cssToRemove);
	}
});
const Services = ({ item }) => {
	const {
		config: { isDark, isRTL },
	} = useContext(AppContext);
	const [t, i18n] = useTranslation();
	return (
		<div className={`${styles.grayServices}`}>
			<div className={`${styles.serviceDetailsTitle} mb-2`}>{t(item.title)}</div>
			<div className="d-flex align-items-center">
				<div className={`${styles.serviceDetailsSVG} me-2`} dangerouslySetInnerHTML={createMarkup(item.icon)} />
				<div className={`${styles.serviceDetailsDescription}`}>{t(item.description)}</div>
			</div>
		</div>
	);
};

export default Services;
